// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3616": "2bd20f1d2224","6131": "c4ead6721250","6495": "a9b28c737317","6863": "454c9f289029",}[chunkId] + ".css"
}